import { ArrowDownToDot, ArrowUpFromDot } from "lucide-react";
import SecondaryButton from "../components/SecondaryButton";
import { useGlideDepositConfig } from "../lib/useDepositConfig";

type Props = {
  onSelect: (mode: "deposit" | "withdraw") => void;
};

export default function ModeSelector({ onSelect }: Props) {
  const depositConfig = useGlideDepositConfig();

  const shouldShowLogo =
    depositConfig.showAppLogo === "always"
      ? true
      : depositConfig.showAppLogo === "never"
        ? false
        : !depositConfig.embed;

  return (
    <div className="mt-6">
      {shouldShowLogo ? (
        <div className="mb-4 flex flex-col items-center justify-center">
          <img
            src={depositConfig.appLogoUrl}
            className="h-[--app-logo-height] w-auto"
            alt={`${depositConfig.appName} Logo`}
          />
        </div>
      ) : null}

      <div className="font-medium text-sm text-[--color-text-primary]">
        Move funds
      </div>
      <div className="text-[--color-text-secondary] text-xs mb-2">
        Select an option to get started
      </div>

      <div className="space-y-2">
        <SecondaryButton
          icon={
            <ArrowDownToDot className="h-5 w-5 text-[--color-text-primary]" />
          }
          title="Deposit"
          subtitle={`Move funds from anywhere into ${depositConfig.appName}`}
          onClick={() => onSelect("deposit")}
        />

        <SecondaryButton
          icon={
            <ArrowUpFromDot className="h-5 w-5 text-[--color-text-primary]" />
          }
          title="Withdraw"
          subtitle={`Move funds from ${depositConfig.appName} to anywhere`}
          onClick={() => onSelect("withdraw")}
        />
      </div>
    </div>
  );
}
